import { defineComponent, h } from "vue";
import { toast } from "vue3-toastify";
import "vue3-toastify/dist/index.css";

const ToastCloseIcon = defineComponent({
  setup() {
    return () => h('button', {
      class: 'mdi mdi-close-circle',
      style: {
        cursor: 'pointer',
        fontSize: '24px',
      },
    });
  },
});

const toastOptions = {
  theme: "colored",
  position: toast.POSITION.TOP_RIGHT,
  autoClose: 5000,
  pauseOnFocusLoss: false,
  closeOnClick: false,
  clearOnUrlChange: false,
  closeButton: ({ closeToast }) => h(ToastCloseIcon, { onClick: closeToast }),
  style: {
    width: 'auto',
    maxWidth: '700px',
  },
  toastStyle: {
    cursor: 'text',
    width: 'fit-content',
    minWidth: '300px',
    marginLeft: 'auto',
  },
};

export default {
  install(app) {
    app.config.globalProperties.$toast = {
      success: (message) => {
        toast.success(message, {
          ...toastOptions,
          toastStyle: {
            ...toastOptions.toastStyle,
            backgroundColor: `rgb(${getComputedStyle(document.documentElement).getPropertyValue('--v-theme-success')})`,
          },
        })
      },
      error: (message) => {
        toast.error(message, {
          ...toastOptions,
          toastStyle: {
            ...toastOptions.toastStyle,
            backgroundColor: `rgb(${getComputedStyle(document.documentElement).getPropertyValue('--v-theme-error')})`,
          },
        })
      },
      info: (message) => {
        toast.info(message, {
          ...toastOptions,
          toastStyle: {
            ...toastOptions.toastStyle,
            backgroundColor: `rgb(${getComputedStyle(document.documentElement).getPropertyValue('--v-theme-info')})`,
          },
        })
      },
      warning: (message) => {
        toast.warning(message, {
          ...toastOptions,
          toastStyle: {
            ...toastOptions.toastStyle,
            backgroundColor: `rgb(${getComputedStyle(document.documentElement).getPropertyValue('--v-theme-warning')})`,
          },
        })
      },
    }
  },
};